import { generatePath, matchPath } from "react-router-dom";
import { SHOW_INFO_EXHIBITOR_PATH, SHOW_INFO_PATH } from "view/routes";

type ScopeShowInfoLinksParams = {
  showId: string;
  exhibitorPairId: string;
};

const toSameOriginUrl = (href: string): URL | null => {
  try {
    const url = new URL(href, window.location.origin);
    return url.origin === window.location.origin ? url : null;
  } catch {
    return null;
  }
};

export const scopeShowInfoLinks = (
  content: string,
  { showId, exhibitorPairId }: ScopeShowInfoLinksParams
): string => {
  if (!content.includes("href")) {
    return content;
  }

  const template = document.createElement("template");
  template.innerHTML = content;
  template.content
    .querySelectorAll<HTMLAnchorElement>("a[href]")
    .forEach((anchor) => {
      const url = toSameOriginUrl(anchor.getAttribute("href") ?? "");
      if (!url) return;

      const matched = matchPath(SHOW_INFO_PATH, url.pathname);
      if (matched?.params.showId !== showId) return;

      url.pathname = generatePath(SHOW_INFO_EXHIBITOR_PATH, {
        showId,
        exhibitorPairId,
      });
      anchor.setAttribute("href", url.toString());
    });

  return template.innerHTML;
};
